/************************************************************************************
	Estas funciones están relacionadas con el sercicio WC del protocolo DVB-CSS,
    que es el encargado de mantener el reloj del cliente sincronizado con el
    reloj del servidor.
************************************************************************************/
import {wallClock} from "../client";


export function getWallClock(cii){

    let wc_ws = new WebSocket(cii.private[0].wsClockUrl, 'echo-protocol');

    // Al abrir el socket se define la frecuencia de ajuste de reloj 
    wc_ws.onopen = function() {
        getWC(wc_ws, 5000);
    }

    wc_ws.onmessage = function(message) {

        // Se realiza el cálculo de la diferencia de tiempos entre el 
        // reloj del servidor y el del cliente y se ajusta este último
        var t4 = wallClock.getTicks();
        var wc_msg = JSON.parse(message.data);
        var offset = ((wc_msg.t3 + wc_msg.t2) - (t4 + wc_msg.t1))/2;
        var RTT = ((t4 - wc_msg.t1) - (wc_msg.t3 - wc_msg.t2))/2;
        wallClock.adjustTicks(offset-RTT);

    }
}

function getWC(wc_ws, millis){

    var startTime = wallClock.getTicks();
	wc_ws.send(JSON.stringify(startTime));
	var wcsettimeout = setTimeout(function() {
		getWC(wc_ws, millis);
	}, millis);
}